module.exports = __webpack_public_path__ + "static/media/completed.0fb8e318.png";